import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const styles = css`
  width: 100%;
  height: 100%;

  ${breakpoints.from.tablet} {
    position: relative;
  }

  ${breakpoints.only.tablet} {
    height: 360px;
  }

  ${breakpoints.to.desktop} {
    *[class*='balloon'] {
      display: none;
    }
  }
`;
